import { usePropsWithComponentTheme } from "native-base";
import React from "react";
import { Button, Icon, Tooltip } from "~/native-ui";

const Delete = React.memo(({onDelete}) => {
    return <Icon colorScheme="muted" size="xs" type='close-thick' iconFamily="material-community" onPress={onDelete} />
})

export const Chip = React.forwardRef((props, ref) => {
    const { active, title, onPress, canDelete, onDelete, tooltip, buttonProps: otherButtonProps, } = props,
          _stack = React.useRef({ space: 2 }).current,
          handleDelete = React.useCallback((e) => {
            e.preventDefault();
            e.stopPropagation();
            onDelete();
          }, [onDelete]),
          buttonProps = {
            ref,
            _stack,
            onPress,
            px: "4",
            icon: props.icon,
            iconFamily: props.iconFamily,
            label: title,
            ghost: active,
            primary: active,
            rounded: "full",
            variant: "outline",
            rightIcon: canDelete ? <Delete key="delete" onDelete={handleDelete} /> : null,
            ...otherButtonProps
          }

    if (!tooltip) return <Button {...buttonProps} />
    
    return <Tooltip tooltip={tooltip}><Button {...buttonProps} /></Tooltip>
});